import React, { useState, useRef } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

function CountDaysInput(props) {
	const { className, placeholder, value, setValue, type, isFull = false } = props;
	const { t } = useLanguage();
	const { isDark } = useTheme();
	const theme = isDark ? darkTheme : lightTheme;

	const [changed, setChanged] = useState(false);
	const [changedPlaceholderColor, setChangedPlaceholderColor] = useState(false);
	const [clickCount, setClickCount] = useState(0);
	const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);

	const inputRef = useRef();

	function onClickInput(e) {
		inputRef.current.style.borderColor = theme.primary;
	}

	function onChangeInput(e) {
    const regex = /[^0-9]/g;
    const result = e.target.value.replace(regex, "");

		if (result === '') setValue(0);
    else if (result < 9999999) setValue(parseInt(result));
		setChanged(true);
	}

	function onFocusInput(e) {
		setChangedPlaceholderColor(false);
	}

	function onBlurInput(e) {
		setClickCount(clickCount + 1);
		inputRef.current.style.borderColor = theme.line;
	}

	return (
    <TopLevelWrapper>
      <Input
        ref={inputRef}
        clickCount={clickCount}
        type={type}
        placeholder={defaultPlaceholder}
        value={value}
        changedColor={changedPlaceholderColor}
        isFull={isFull}
        className={`${className} ${changed ? "changed" : ""}`}
        onClick={onClickInput}
        onChange={onChangeInput}
        onFocus={onFocusInput}
        onBlur={onBlurInput} />
        <Text>{t('main.locker.dayUnit')}</Text>
    </TopLevelWrapper>
  )
}

export default CountDaysInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 5px;
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const Input = styled.input`
  text-align: right;
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 20px;

	padding: 0 8px 0 8px;

  width: ${props => props.isFull ? '100%' : '98px'};
  height: 30px;

	outline: none;
  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.theme.subBackground};

	color: ${props => props.theme.text};

	::placeholder {
		color: ${props => props.changedColor ? props.theme.pointRed : props.theme.line};
	}

	&::-webkit-scrollbar {
		width: 4px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: ${props => props.theme.scrollBar};
		border-radius: 4px;
	}

	&::-webkit-scrollbar-track {
		background-color: ${props => props.theme.subBackground};
	}

  transition: all 0.3s ease-in-out;
`;
